/*
 * Who may hand out which role. The platform roles are ordered; a caller
 * never grants or removes a role above their own level, SuperAdmin apart.
 */

/** Lowest to highest privilege. */
export const ROLE_HIERARCHY = ['Viewer', 'ClientAdmin', 'Operator', 'Admin', 'SuperAdmin'] as const;

export const roleLevel = (role: string): number => ROLE_HIERARCHY.indexOf(role as (typeof ROLE_HIERARCHY)[number]);

/** The highest level among a user's roles, -1 when they hold none. */
export const highestRoleLevel = (roles: string[] | undefined): number =>
  (roles || []).reduce((max, role) => Math.max(max, roleLevel(role)), -1);

/** Whether a caller at `callerLevel` may grant or remove `role`. */
export const canManageRoleAtLevel = (role: string, callerLevel: number, callerIsSuperAdmin: boolean): boolean => {
  if (callerIsSuperAdmin) return true;
  const level = roleLevel(role);
  return level >= 0 && level <= callerLevel;
};

/** The client UUID a Keycloak group path points at ("/Clients/<uuid>/dev"), if any. */
export const clientIdFromGroupPath = (path: string): string | null => {
  const match = path.match(/\/Clients\/([a-f0-9-]+)/i);
  return match ? match[1] : null;
};
